module.exports = __webpack_public_path__ + "img/Logo-Teneo-500x200-transparant.43c4c7a4.png";